<div class="password-input">
    <input type="password" [name]="id" [id]="id" *ngIf="!autoComplete" tabindex="-1" />
    <input
        [type]="fieldTextType ? 'text' : 'password'"
        class="password-input__primary"
        [id]="id"
        #inputEl
        autocomplete="{{ autoComplete }}"
        [value]="value"
        [required]="required"
        [disabled]="disabled"
        (change)="onChange()"
        (input)="onChange()"
        (blur)="onBlur()"
    />
    <svg-image *ngIf="fieldTextType; else closeEye" name="eye-open" (click)="isFieldTextType()"></svg-image>
    <ng-template #closeEye>
        <svg-image name="eye-close" (click)="isFieldTextType()"></svg-image>
    </ng-template>
</div>
